module.exports = __webpack_public_path__ + "ab12526f2d63b78d9a492b9bbce19da4.svg";